const DOC_IDENTIFIER = /^DOC-([1-9][0-9]{0,18})$/i;
const MAX_DOC_NUMBER = BigInt("9223372036854775807");

/** Exact DOC namespace only; UUIDs, issue identifiers and abbreviated IDs fail. */
export function parseDocIdentifier(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const match = DOC_IDENTIFIER.exec(value.trim());
  if (!match || BigInt(match[1]) > MAX_DOC_NUMBER) return null;
  return `DOC-${match[1]}`;
}

/** Use the server-assigned identity. An optimistic/legacy absence stays unknown. */
export function docIdentifier(doc: { identifier?: string | null } | null | undefined): string | null {
  return parseDocIdentifier(doc?.identifier);
}

/** Search callers must also constrain their inventory/query to the active workspace. */
export function matchesDocIdentifier(
  doc: { identifier?: string | null } | null | undefined,
  query: unknown,
): boolean {
  const identifier = parseDocIdentifier(query);
  return identifier !== null && docIdentifier(doc) === identifier;
}
